$(document).ready(function () {
        //mobilewarn

        // mobileWarn();


        //tour

        window.tour1 =
            [
                {
                    element: '#pcEditorRightHeaderAutoFill',
                    text: 'Auto Fill Proper Template : <br> Click this button to find proper template for uploaded images and auto fill . <br>'
                },
                {
                    element: '#pcEditorRightHeaderTemplate',
                    text: 'Templates : <br> Click this button to show all template that you can select. <br>'
                },
                {
                    element: '#pcEditorRightHeaderTemplate',
                    text: 'Empty Template : <br> Click this button to empty template and redesign. <br>'
                },
                {
                    element: '#pcEditorRightHeaderEmpty',
                    text: 'Background : <br> Click this button to change background color of collage. <br>'
                },
                {
                    element: '#pcEditorRightHeaderBackground',
                    text: 'White & Black color : <br> Click this button to W&B color all of images. <br>'
                },
                {
                    element: '#pcEditorRightHeaderBW',
                    text: 'Add Text : <br> Click this button to add any text to your photo collage. <br>'
                },
                {
                    element: '#pcEditorRightHeaderAddText',
                    text: 'New Project : <br> Click this button to create a new photo collage. <br>'
                },
                {
                    element: '#pcEditorRightHeaderNew',
                    text: 'Open Project : <br> Click this button to open your project that saved. <br>'
                },
                {
                    element: '#pcEditorRightHeaderOpen',
                    text: 'Save Project : <br> Click this button to save your project. you can edite this project later by open project. <br>'
                }
            ];

        function pcSetCookie(c_name, value, exdays) { var exdate = new Date(); exdate.setDate(exdate.getDate() + exdays); var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString()); document.cookie = c_name + "=" + c_value; }

        function pcGetCookie(c_name) { var c_value = document.cookie; var c_start = c_value.indexOf(" " + c_name + "="); if (c_start == -1) { c_start = c_value.indexOf(c_name + "="); } if (c_start == -1) { c_value = null; } else { c_start = c_value.indexOf("=", c_start) + 1; var c_end = c_value.indexOf(";", c_start); if (c_end == -1) { c_end = c_value.length; } c_value = unescape(c_value.substring(c_start, c_end)); } return c_value; }

        function pcShowTour(target) {
            let prefix = "photoCollage-Tour";
            if (!(pcGetCookie(prefix + target) === "yes")) {
                //pcSetCookie(prefix+target, "yes", 365);
                // TourStart(window["tour" + target]);
            }
            else {
                // TourStart(window["tour" + target]);
            }
        }

        //filestack

        // filestackCallback = pcFileAdd;
        // $(".pcEditorLeftUploadArea").click(function () {
        //     filestackShow();
        // });

        // $("body").on("click",".filestakQueryLocal",function () {
        //     $("#pcEditorLeftUploadAreaFile").get(0).click();
        //     $(".filestakQuery").hide();
        // });

        // $("body").on("click",".filestakQueryCloud",function () {
        //     $(".filestakQuery").hide();
        //     filestackClient.picker(filestackPickerOption).open();
        // });

        // $("body").on("click",".filestakClose",function(){
        //     $(".filestakQuery").hide();
        // });


        //Global
        if ($(".photoCollage").length === 0)
            return;

        function pcDataSet() {
            this.sizes = '';
            this.def =
            {
                dpi: 300,
                // serverSidePath : 'https://canadaphotolab.com/wp-content/themes/astra/template-parts/photoCollage',
                // serverSidePath : 'https://canadaphotolab.com/wp-content/themes/astra/demo/photoCollage/v4',
                serverSidePath: 'https://canadaphotolab.com/wp-content/themes/printspace/template-parts/PhotoCollage',
                // serverSidePath: 'http://localhost/photocollage',
                zoomMax: 1,
                templateVersion: 3
            }
            this.cur =
            {
                working: false,
                ratio: 1,
                bw: false,
                drag: false,
                dragStart: -1,
                projectName: '',
                templateSrc: '',
                templateOri: '',
                template: '',
                otherObj: [],
                backgroundImage: '',
                mode: '',
                loadingShow: false,
                mouseTarget: ''
            }
            this.image =
            {
                id: 0,
                list: []
            }
            this.fabric =
            {
                mainCanvas: '',
                maxWidth: 630,//$(".pcEditorRightEditArea").width() * 0.85,
                maxHeigth: 510,//$(".pcEditorRightEditArea").height() * 0.85,
                images: [],
                dim: []
            }
            this.template =
            {
                list: [],
                jsonList: []
            }
        }
        let pc = new pcDataSet();

        //Functions

        pcStart();

        function pcStart() {
            pcLoadingShow();
            pcGetData(function () {
                pcFabricCreate();
                pcFabricTemplateChange();
                pcLoadingHide();
                pcTemplateUpdateList();
                pcQueryCheck();
                pcFinishListUpdate();
            });
        }

        function pcQueryCheck() {
            const url = new URL(window.location.href);
            var project = url.searchParams.get("project");
            var tempFile = url.searchParams.get("tempFile");
            var action = url.searchParams.get("action");
            var mode = url.searchParams.get("mode");
            var imgSrc = url.searchParams.get("imgSrc");
            if (project != null) {
                pcLoadingShow("Processing...");
                pcProjectRestore(decodeURIComponent(project));
            }
            else if (tempFile != null) {
                pcLoadingShow("Processing...");
                pcProjectSave(decodeURIComponent(project));
            }
            else if (action != null) {
                $("#pcEditorRightHeaderOpen").click();
            }
            else if (mode != null) {
                pc.cur.mode = mode;
                pcTemplateUpdateList();
            }

            if(imgSrc != null)
            {
                pcFileAddFromUrl(imgSrc)
            }
        }

        function pcFileAddFromUrl(url) {
  pcLoadingShow("Processing images...");
  pc.cur.working = true;

  if (!url || typeof url !== "string") {
    console.error("Invalid imgSrc URL");
    pcLoadingHide();
    return;
  }

  var imageUrls = url.split("|||").filter(function (u) { return u && u.trim() !== ""; });
  var count = 0;

  addNext();

  function addNext() {
    if (count >= imageUrls.length) {
      $("#pcEditorLeftUploadAreaFile").val("");
      pcImageUpdateList();
      // مخفی کردن سکشن شاپیفای مورد نظر
      $("#photoStart,#shopify-section-template--20207267086571__sh_tab_wise_image_2_9mFaHk").hide();
      $(".photoCollage").show();
      pcLoadingHide();
      return;
    }

    // 1) گرفتن امن تصویر به صورت Blob
    $.ajax({
      url: imageUrls[count],
      method: "GET",
      xhrFields: { responseType: "blob" },
      success: function (blob) {
        // 2) تبدیل Blob به Base64 (برای جلوگیری از taint)
        var reader = new FileReader();
        reader.onloadend = function () {
          var base64Image = reader.result;

          // 3) ساخت thumbnail روی canvas داخلی (ایمن)
          var thumbImg = new Image();
          thumbImg.src = base64Image;
          thumbImg.onload = function () {
            var maxWidht = pc.fabric.maxWidth;
            var maxHeigth = pc.fabric.maxHeigth;
            var maxRatio = maxWidht / maxHeigth;

            var imageRatio = thumbImg.width / thumbImg.height;
            var scale = (imageRatio <= maxRatio) ? (maxWidht / thumbImg.width) : (maxHeigth / thumbImg.height);

            var width = thumbImg.width * scale;
            var height = thumbImg.height * scale;

            var thumbCanvas = document.createElement("canvas");
            thumbCanvas.width = width;
            thumbCanvas.height = height;
            var ctx = thumbCanvas.getContext("2d");
            ctx.drawImage(thumbImg, 0, 0, width, height);

            var thumbBase64 = thumbCanvas.toDataURL("image/jpeg");

            var filters = [];
            if (pc.cur.bw) {
              filters[0] = new fabric.Image.filters.Grayscale();
            }

            pc.image.list.push({
              id: pc.image.id++,
              name: imageUrls[count].replace(/^.*[\\/]/, ""),
              lastModified: "",
              src: base64Image,     // منبع اصلی هم Base64 می‌ماند تا CORS نداشته باشیم
              thumbSrc: thumbBase64,
              usage: 0,
              filters: filters
            });

            count++;
            addNext();
          };

          thumbImg.onerror = function () {
            console.error("Thumb build failed:", imageUrls[count]);
            count++;
            addNext();
          };
        };

        reader.onerror = function () {
          console.error("Base64 convert failed:", imageUrls[count]);
          count++;
          addNext();
        };

        reader.readAsDataURL(blob);
      },
      error: function () {
        console.error("Fetch failed:", imageUrls[count]);
        count++;
        addNext();
      }
    });
  }
}


        function pcGetData(callback = function () { }) {
            var templateCounter = 0;
            var list = "";
            var jsonList = "";
            var nameList = '';
            var thumbList = '';

            var jsonCount = 0;
            var svgCount = 0;

            getJsonTemplateList();

            function getJsonTemplateList() {
                $.ajax({
                    url: pc.def.serverSidePath + "/getJsonTemplateList.php",
                    method: "POST",
                    data: {
                        templateDir: 'photoCollageTemplateSaves'
                    },
                    success: function (data) {
                        jsonList = data.split("\n");
                        addJsonTemplates();
                    },
                    error: function (data) {
                        console.log(data);
                    }
                })
            }

            function addJsonTemplates() {
                jsonList.forEach(function (item) {
                    if (item !== "") {
                        var fullName = item.replace("photoCollageTemplateSaves/", "");
                        fullName = fullName.replace(".json", "");
                        var thumbSrc = pc.def.serverSidePath + "/photoCollageTemplateSaves/" + fullName + ".jpeg";
                        fullNameArray = fullName.split("-");
                        var backgroundImage = pc.def.serverSidePath + "/photoCollageTemplateSaves/" + fullNameArray[0] + ".jpg"

                        pc.template.list.push({
                            fullName: fullName,
                            count: fullNameArray[2],
                            ori: fullNameArray[1],
                            name: fullNameArray[0],
                            thumbSrc: thumbSrc,
                            backgroundImage: backgroundImage,
                            type: "json"
                        });
                    }
                });

                getSvgTemplates();
            }

            function getSvgTemplates() {
                $.ajax({
                    url: pc.def.serverSidePath + "/getTemplateList.php",
                    method: "POST",
                    data: {
                        templateDir: 'pics/templates'
                    },
                    success: function (data) {
                        list = data.split("\n");
                        getSvgTemplatesThumb();
                    },
                    error: function (data) {
                        console.log(data);
                    }
                })
            }

            function getSvgTemplatesThumb() {
                $.ajax({
                    url: pc.def.serverSidePath + "/getTemplateThumbList.php",
                    method: "POST",
                    data: {
                        templateDir: 'pics/templates'
                    },
                    success: function (data) {
                        thumbList = data;
                        addTemplate();
                    },
                    error: function (data) {
                        console.log(data);
                    }
                })
            }

            function addTemplate() {
                if (templateCounter === list.length - 1) {
                    getJsonData();
                    return;
                }

                var format = list[templateCounter].split(".")
                format = format[format.length - 1];
                if (format != "svg") {
                    addTemplate();
                    return;
                }

                let src = pc.def.serverSidePath + '/' + list[templateCounter];

                var thumbSrc = src.replace(".svg", ".jpeg");

                let name = src.substring(src.lastIndexOf('/') + 1);
                name = name.split('.').slice(0, -1).join('.');
                ori = name.split('-');
                ori = ori[ori.length - 1];
                name = name.split('-').slice(0, -1).join('-');
                name = name.substring(6, name.length);

                nameList += '"' + name + '-' + ori + '",\n'

                var thumbName = list[templateCounter].replace(".svg", ".jpeg");
                if (thumbList.includes(thumbName)) {
                    pc.template.list.push({
                        src: src,
                        ori: ori,
                        name: name,
                        thumbSrc: thumbSrc,
                        type: "svg"
                    });
                }
                else {
                    pc.template.list.push({
                        src: src,
                        ori: ori,
                        name: name,
                        thumbSrc: "404",
                        type: "svg"
                    });
                }

                templateCounter++;
                addTemplate();

            }

            function getJsonData() {
                $.getJSON(pc.def.serverSidePath + "/photoCollage.json?ver=7", function (data) {
                    pc.finish = data.finish;
                    pc.cat = data.cat;
                    callback();
                });
            }
        }

        function pcTemplateShow() {
            $(".pcTemplate").show();
            $("body").css("overflow", "hidden");
        }

        function pcTemplateHide() {
            $(".pcTemplate").hide();
            $("body").css("overflow", "auto");
        }

        function pcLoadingShow(text = "Loading...") {
            pc.cur.loadingShow = true;
            $(".pcLoadingText").html(text)
            $(".pcLoading").show();
        }

        function pcLoadingHide() {
            pc.cur.loadingShow = false;
            $(".pcLoading").hide();
        }

        function pcFileAdd(fileList) {

            pcLoadingShow("Processing images...");
            pc.cur.working = true;

            let count = 0;
            pcFileAddOneFile(fileList[count]);

            function pcFileAddOneFile(file) {

                if (count >= fileList.length) {
                    $("#pcEditorLeftUploadAreaFile").val("");
                    pcImageUpdateList();

                    $("#photoStart,#shopify-section-template--20207267086571__sh_tab_wise_image_2_9mFaHk").hide();
                    $(".photoCollage").show();

                    pcLoadingHide();
                    return;
                }

                if (!file.type.match('image')) {
                    alert(file.name + " is not image file.");
                    count++;
                    pcFileAddOneFile(fileList[count]);
                    return;
                }

                let picReader = new FileReader();
                picReader.readAsDataURL(file);

                picReader.onload = function () {

                    let thumbImg = new Image();
                    thumbImg.src = picReader.result;
                    thumbImg.onload = function () {

                        let maxWidht = pc.fabric.maxWidth;
                        let maxHeigth = pc.fabric.maxHeigth;
                        let maxRatio = maxWidht / maxHeigth;

                        let imageWidth = thumbImg.width;
                        let imageHeigth = thumbImg.height;
                        let imageRatio = imageWidth / imageHeigth;

                        let scale;
                        if (imageRatio <= maxRatio)
                            scale = maxWidht / imageWidth;
                        else
                            scale = maxHeigth / imageHeigth;


                        let width = thumbImg.width *= scale;
                        let height = thumbImg.height *= scale;

                        let thumbCanvas = document.createElement("canvas");
                        thumbCanvas.width = width;
                        thumbCanvas.height = height;

                        let thumbCanvasCtx = thumbCanvas.getContext("2d");
                        thumbCanvasCtx.drawImage(thumbImg, 0, 0, width, height);
                        thumbImg.src = thumbCanvas.toDataURL('image/jpeg');

                        thumbImg.onload = function () {
                            let id = pc.image.id++;

                            let filters = [];
                            if (pc.cur.bw)
                                filters[0] = new fabric.Image.filters.Grayscale();

                            pc.image.list.push({
                                id: id,
                                name: file.name,
                                lastModified: file.lastModified,
                                src: picReader.result,
                                thumbSrc: thumbImg.src,
                                usage: 0,
                                filters: filters
                            });

                            count++;
                            pcFileAddOneFile(fileList[count]);
                        }
                    }
                }
                picReader.onerorr = function () {
                    alert("Can't read this file : " + file.name);
                    count++;
                    pcFileAddOneFile(fileList[count]);
                }
            }
        }

        function pcImageRemoveAll() {
            pc.cur.working = true;

            if (!confirm("Are you sure you want delete all images?"))
                return;

            pc.fabric.images = [];
            pc.image.list = [];

            pcFabricFillAll("#eeeeee");
            pcImageUpdateList();
        }

        function pcImageRemove(elm) {
            pc.cur.working = true;

            if (!confirm("Are you sure you want delete this image?"))
                return;

            let target = parseInt($(elm).parent().attr("id").replace("pcImage", ""));

            for (let i = pc.fabric.mainCanvas._objects.length - 1; i >= 0; i--) {
                if (pc.fabric.images[i] !== undefined) {
                    if (pc.fabric.images[i] === target) {
                        pc.fabric.mainCanvas._objects[i].set("fill", "#eeeeee");
                        // pc.fabric.images.splice(i, 1);
                        pc.fabric.images[i] = undefined;
                    }
                }
            }
            pc.fabric.mainCanvas.renderAll();

            target = pc.image.list.findIndex(item => item.id === target);
            pc.image.list.splice(target, 1);
            pcImageUpdateList();
        }

        function pcImageUpdateList(autoFill = true) {
            pc.cur.working = true;

            let prevListCount = $(".pcEditorLeftImageList").children().length;

            $(".pcEditorLeftImageList").html("");
            $(".pcEditorLeftFuncsDeleteAll").html("Delete all photos (" + pc.image.list.length + ")");
            pc.cur.working = true;

            for (let i = 0; i < pc.image.list.length; i++) {
                if (pc.image.list[i].usage === 0) {
                    $(".pcEditorLeftImageList").append(
                        '<div class="pcEditorLeftImage" id="pcImage' + pc.image.list[i].id + '" data-usage="0">' +
                        '<img src="' + pc.image.list[i].thumbSrc + '">' +
                        '<div class="pcEditorLeftImageDelete">X</div>' +
                        '</div>'
                    );
                }
                else {
                    $(".pcEditorLeftImageList").append(
                        '<div class="pcEditorLeftImage" id="pcImage' + pc.image.list[i].id + '">' +
                        '<img src="' + pc.image.list[i].thumbSrc + '">' +
                        '<div class="pcEditorLeftImageUsage">' + pc.image.list[i].usage + '</div>' +
                        '<div class="pcEditorLeftImageDelete">X</div>' +
                        '</div>'
                    );
                }
            }

            if (prevListCount === 0 && pc.image.list.length > 0 && autoFill) {
                //auto proper template
                //pcFabricAutoFill(true);

                pcShowTour(1);
            }

            // $(".pcEditorLeftImageList").children().draggable({
            //     revert: true,
            //     iframeFix: true,
            //     helper: function () {
            //         $(this).find(".pcEditorLeftImageDelete").hide();
            //         $(this).find(".pcEditorLeftImageUsage").hide();
            //         return $(this).clone();
            //     },
            //     appendTo: '.photoCollage',
            //     revert: 'invalid',
            //     // drag: function (event) {
            //     //     pcFabricDragging(event);
            //     // }
            // });
        }

        function pcDropDragOver() {
            $(".pcEditorLeftUploadArea").addClass("pcEditorLeftUploadAreaDrag");
        }

        function pcDropDragLeave() {
            $(".pcEditorLeftUploadArea").removeClass("pcEditorLeftUploadAreaDrag");
        }

        function pcShowImageTools(e) {

            e = e.target;
            if (e == null || e == undefined || e.type != "path" || e.fill !== "#eeeeee") {
                return;
            }
            var canvas = pc.fabric.mainCanvas;

            if ($("#pcToolTip").length === 0) {
                $("body").append("<div id='pcToolTip' class='pcToolTip'>Drag Here</div>");
            }
            moveImageTools();

            function moveImageTools() {
                var w = $('#pcToolTip').width();
                var h = $('#pcToolTip').height();
                // var e = canvas.getActiveObject();
                var coords = getObjPosition(e);
                // -1 because we want to be inside the selection body
                var top = (coords.top + ((coords.bottom - coords.top) / 2)) - (h / 2);
                var left = (coords.left + ((coords.right - coords.left) / 2)) - (w / 2);
                $('#pcToolTip').show();
                $('#pcToolTip').css({ top: top, left: left });
            }

            function getObjPosition(e) {
                // Get dimensions of object
                var rect = e.getBoundingRect();
                // We have the bounding box for rect... Now to get the canvas position
                var offset = canvas.calcOffset();
                // Do the math - offset is from $(body)
                var bottom = offset._offset.top + rect.top + rect.height;
                var right = offset._offset.left + rect.left + rect.width;
                var left = offset._offset.left + rect.left;
                var top = offset._offset.top + rect.top;
                return { left: left, top: top, right: right, bottom: bottom };
            }

        }




        function pcFabricCreate() {
            pc.cur.working = true;

            pc.fabric.mainCanvas = new fabric.Canvas('pcMainCanvas');

            pc.fabric.mainCanvas.set({
                uniScaleTransform: true,
                enableRetinaScaling: true,
                uniScaleKey: "none",
                selection: false,
                containerClass: "pcMainCanvas",
                controlsAboveOverlay: false,
                backgroundColor: "#ffffff",
                perPixelTargetFind: false,
                preserveObjectStacking: true
            });

            pcFabricUpdateRatio();

            pc.fabric.mainCanvas.backgroundColor.repeat = 'repeat';

            pc.fabric.mainCanvas.renderAll();

            //actions
            pc.fabric.mainCanvas.on("mouse:down", function (options) {
                pcOptSyns();
            });

            pc.fabric.mainCanvas.on('mouse:over', function (e) {
                pcShowImageTools(e);
            });

            pc.fabric.mainCanvas.on('mouse:out', function (e) {
                if (e.e.toElement.id !== "pcToolTip") {
                    $('#pcToolTip').hide();
                }
            });





            //delete button
            var deleteIcon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:red;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
            var img = document.createElement('img');
            img.src = deleteIcon;

            function renderIcon(ctx, left, top, styleOverride, fabricObject) {
                var size = this.cornerSize;
                ctx.save();
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.drawImage(img, -size / 2, -size / 2, size, size);
                ctx.restore();
            }

            fabric.Object.prototype.controls.deleteControl = new fabric.Control({
                x: 0.5,
                y: -0.5,
                offsetY: 8,
                offsetX: -8,
                cursorStyle: 'pointer',
                mouseUpHandler: pcFabricImageRemove,
                render: renderIcon,
                cornerSize: 24
            });
        }

        function pcFabricUpdateRatio() {
            let height = 0;
            let width = 0;
            let fabricRatio = pc.fabric.maxWidth / pc.fabric.maxHeigth;

            if (pc.cur.ratio === fabricRatio) {
                width = pc.fabric.maxWidth;
                height = pc.fabric.maxHeigth;
            }
            else if (pc.cur.ratio > fabricRatio) {
                width = pc.fabric.maxWidth;
                height = width / pc.cur.ratio;
            }
            else if (pc.cur.ratio < fabricRatio) {
                height = pc.fabric.maxHeigth;
                width = height * pc.cur.ratio;
            }

            pc.fabric.mainCanvas.setWidth(width).setHeight(height)
        }

        function pcFabricTemplateChange(id = "random", autoFill = true, useCurrent = false) {
            pc.cur.working = true;

            pcFabricClean();

            // if (id === "random") {
            //     while(id == "random")
            //     {
            //         var tempId = Math.floor(Math.random() * pc.template.list.length);

            //         if(pc.template.list[tempId].type === "svg")
            //         {
            //             id = tempId;
            //         }
            //     }
            // }

            if (id === "random") {
                id = pc.template.list.findIndex(item => item.name == "Standard.004002");
            }

            var tem;

            if (useCurrent) {
                tem = pc.cur.template;
                tem.src = pc.cur.templateSrc;
                resume();
            }
            else {
                tem = pc.template.list[id];
                pcLoadingShow();

                fabric.loadSVGFromURL(tem.src + "?ver=" + pc.def.templateVersion, function (objects, options) {
                    tem.objects = objects;
                    tem.options = options;

                    pc.cur.templateSrc = tem.src;
                    pc.cur.template = tem;
                    
                    resume();
                    pcLoadingHide();
                });
            }

            function resume() {
                pc.cur.ratio = tem.options.viewBoxWidth / tem.options.viewBoxHeight;
                pcFabricUpdateRatio();

                let scale = pc.fabric.mainCanvas.getWidth() / tem.options.viewBoxWidth;

                pc.cur.templateOri = tem.ori.toLowerCase();

                for (let i = 0; i < tem.objects.length; i++) {
                    obj = tem.objects[i];

                    if (obj.path === undefined) {
                        obj.path = "";

                        for (let j = 0; j < obj.points.length; j++) {
                            obj.path += (j && "L" || "M") + obj.points[j].x + ',' + obj.points[j].y
                        }
                    }

                    let path = new fabric.Path(obj.path)

                    path.set({
                        fill: "#eeeeee",
                        left: path.left * scale,
                        top: path.top * scale,
                        lockMovementX: true,
                        lockMovementY: true,
                        hasControls: false,
                        borderColor: "#053a31"
                    })

                    path.setControlsVisibility({
                        'tl': false,
                        'tr': false,
                        'br': false,
                        'bl': false,
                        'ml': false,
                        'mr': false,
                        'mt': false,
                        'mb': false,
                        'mtr': false
                    }),
                        path.scaleToWidth(path.width * scale);

                    path.on('dragenter', function (e) {
                        pcFabricFillAll('#a3dae0');
                        if (typeof path.fill === "string") {
                            e.target.set('fill', '#3bc1cf');
                        }
                        pc.fabric.mainCanvas.renderAll();
                    });

                    path.on('dragleave', function (e) {
                        pcFabricFillAll('#eeeeee');
                    });

                    path.on('drop', function (e) {
                        pcFabricFillAll('#eeeeee');

                        if (pc.cur.imageListDragStart !== false) {
                            pcFabricAddImage(e.target, pc.cur.imageListDragStart);
                        }
                    });

                    path.on("mousedown", function (e) {

                        pcFabricFixControls(e);

                        pc.cur.drag = true;
                        pc.cur.dragStart = e;

                        var pathIndex = pc.fabric.mainCanvas._objects.indexOf(e.target);
                        pc.fabric.dim[pathIndex].movedXLast = pc.fabric.dim[pathIndex].movedX;
                        pc.fabric.dim[pathIndex].movedYLast = pc.fabric.dim[pathIndex].movedY;

                        if (
                            $(e.target).attr("id") !== "pcEditorRightHeaderBackground" &&
                            $(e.target).attr("id") !== "pattern" &&
                            $(e.target).attr("id") !== "empty"
                        ) {
                            $(".pcEditorRightHeaderPattern").hide();
                        }
                    });

                    path.on("mouseup", function (e) {
                        pc.cur.drag = false;
                    });

                    path.on("mousemove", function (e) {
                        pcFabricMoveImage(e);
                    });



                    // path.width = path.scaleX * path.width;
                    // path.height = path.scaleY * path.height;
                    // path.scaleX = 1;
                    // path.scaleY = 1;
                    // pc.fabric.mainCanvas.renderAll();

                    //set dim
                    pc.fabric.dim[i] = {
                        scale: 1,
                        offsetX: 0,
                        offsetY: 0,
                        movedX: 0,
                        movedY: 0
                    }

                    pc.fabric.mainCanvas.add(path);
                }

                pc.fabric.mainCanvas.renderAll();

                if (pc.image.list.length > 0 && autoFill) {
                    //auto proper template
                    //pcFabricAutoFill();
                }


                pcFinishListUpdate();
            }
        }

        function pcFabricFixControls(e) {
            if (e.target.type == "path") {
                e.target.setControlsVisibility({
                    'tl': false,
                    'tr': false,
                    'br': false,
                    'bl': false,
                    'ml': false,
                    'mr': false,
                    'mt': false,
                    'mb': false,
                    'mtr': false
                });
                pc.fabric.mainCanvas.renderAll();
            }
            else if (e.target.type == "textbox") {
                e.target.setControlsVisibility({
                    'tl': true,
                    'tr': true,
                    'br': true,
                    'bl': true,
                    'ml': true,
                    'mr': true,
                    'mt': true,
                    'mb': true,
                    'mtr': true
                });
                pc.fabric.mainCanvas.renderAll();
            }
        }

        function pcFabricClean() {
            pc.cur.working = true;

            pcFabricBackgroundImageClear()

            pc.fabric.mainCanvas.setBackgroundColor("#ffffff", function () {
                pc.cur.backgroundColor = "#ffffff";
                pc.fabric.mainCanvas.renderAll();
            });

            for (let i = pc.fabric.mainCanvas._objects.length - 1; i >= 0; i--) {
                pc.fabric.mainCanvas.remove(pc.fabric.mainCanvas._objects[i]);
            }
            pc.fabric.images = [];
            for (let i = 0; i < pc.image.list.length; i++) {
                pc.image.list[i].usage = 0;
            }

            pcImageUpdateList();
        }

        function pcFabricEmpty() {
            pc.cur.working = true;

            pc.fabric.images = [];
            for (let i = 0; i < pc.image.list.length; i++) {
                pc.image.list[i].usage = 0;
            }

            pcFabricFillAll("#eeeeee");

            pcImageUpdateList();
        }

        function pcFabricOver(event, ui) {
            pcFabricFillAll('#a3dae0');

            pc.fabric.mainCanvas.renderAll();
        }

        function pcFabricOut(event, ui) {
            pcFabricFillAll('#eeeeee');

            pc.fabric.mainCanvas.renderAll();
        }

        function pcFabricDragging(event) {
            pc.cur.working = true;

            pcFabricFillAll('#eeeeee');

            let curX = event.pageX - $(".pcEditorRightEditAreaCon").offset().left;
            let curY = event.pageY - $(".pcEditorRightEditAreaCon").offset().top;
            if (curX < 0 || curY < 0)
                return;

            pcFabricFillAll('#a3dae0');

            let path = pcFabricFindTarget(event)
            if (path !== -1) {
                if (typeof path.fill === "string")
                    path.set('fill', '#3bc1cf');
            }

            pc.fabric.mainCanvas.renderAll();
        }

        function pcFabricFillAll(color) {
            let objects = pcFabricGetImageObjects();

            for (let i = objects.length - 1; i >= 0; i--) {
                if (pc.fabric.images[i] === undefined)
                    objects[i].set('fill', color);
            }

            pc.fabric.mainCanvas.renderAll();
        }

        function pcFabricDrop(event, ui) {
            let path = pcFabricFindTarget(event);
            if (path !== -1) {
                pcFabricAddImage(path, ui.draggable[0], function () {
                    pcFabricOut(event, ui);
                });
            }

            pc.fabric.mainCanvas.renderAll();
        }

        function pcFabricFindTarget(event) {

            if (pc.cur.mouseTarget.type == "path") {
                return pc.cur.mouseTarget;
            }
            else {
                return -1;
            }

            // let curX = event.pageX - $(".pcEditorRightEditAreaCon").offset().left;
            // let curY = event.pageY - $(".pcEditorRightEditAreaCon").offset().top;

            // target = -1;

            // let objects = pcFabricGetImageObjects();
            // for (let i = 0; i < objects.length; i++) {
            //     let path = objects[i];
            //     let scale = path.scaleX

            //     if (
            //         curX >= path.left && curX <= (path.width * scale) + path.left &&
            //         curY >= path.top && curY <= (path.height * scale) + path.top
            //     ) {
            //         target = path;
            //         break;
            //     }
            // }

            // return target;
        }

        function pcFabricBW() {
            pc.cur.working = true;

            if (pc.cur.bw) {
                pc.cur.bw = false;
                pc.image.list.forEach(function (image) {
                    image.filters = [];
                });
            }
            else {
                pc.cur.bw = true;
                pc.image.list.forEach(function (image) {
                    image.filters[0] = new fabric.Image.filters.Grayscale();
                });
            }

            pcFabricRefresh();
        }

        function pcFabricRefresh(callback = function () { }) {
            pc.cur.working = true;

            pcLoadingShow("Processing...");

            let pathList = pcFabricGetImageObjects();
            let pathCounter = 0;
            refresh();

            function refresh() {
                if (pathCounter === pathList.length) {
                    //set background
                    if (pc.cur.backgroundColor !== undefined)
                        pc.fabric.mainCanvas.setBackgroundColor(pc.cur.backgroundColor);

                    //set saved text
                    pc.cur.otherObj.forEach(function (savedObj, i) {
                        if (savedObj.type === "textbox") {
                            let obj = new fabric.Textbox(savedObj.text, {
                                left: savedObj.left,
                                top: savedObj.top,
                                centeredRotation: true,
                                objectCaching: false,
                                cornerStyle: "circle",
                                cornerSize: 8,
                                borderColor: "#555555",
                                cornerColor: "#053a31",
                                cornerStrokeColor: "#053a31",
                                fill: savedObj.fill,
                                fontFamily: savedObj.fontFamily,
                                width: savedObj.width,
                                height: savedObj.height,
                                scaleX: savedObj.scaleX,
                                scaleY: savedObj.scaleY,
                                fontSize: savedObj.fontSize,
                                angle: savedObj.angle
                            });
                            obj.setControlsVisibility({
                                'tl': true,
                                'tr': true,
                                'br': true,
                                'bl': true,
                                'ml': true,
                                'mr': true,
                                'mt': true,
                                'mb': true,
                                'mtr': true
                            });
                            obj.on("mousedown", function (e) {
                                pcFabricFixControls(e);
                            });
                            pc.fabric.mainCanvas.add(obj);
                        }
                    });

                    pc.fabric.mainCanvas.renderAll();

                    pcLoadingHide();
                    callback();
                    return;
                }

                let pathId = pc.fabric.mainCanvas._objects.indexOf(pathList[pathCounter]);

                pcFabricFitImage(pathId, false, function () {
                    pathCounter++;
                    refresh();
                });
            }
        }

        function pcFabricAutoFill(findTemplate = false) {
            pc.cur.working = true;

            var usage = pc.image.list.filter(item => item.usage > 0);
            if (usage.length > 0) {
                if (!confirm("Your design will be earased, Are you sure you want continue?")) {
                    return;
                }
            }

            // if (pc.image.list.length === 0) {
            //     alert("Please add images first.");
            //     return;
            // }

            pcFabricEmpty();

            if (findTemplate) {
                let list = pc.template.list.filter(item => item.objects.length === pc.image.list.length);

                if (list.length === 0)
                    list = pc.template.list.filter(item => item.objects.length === (pc.image.list.length + 1));
                if (list.length === 0)
                    list = pc.template.list.filter(item => item.objects.length === (pc.image.list.length + 2));
                if (list.length === 0)
                    list = pc.template.list.filter(item => item.objects.length > pc.image.list.length);

                if (list.length !== 0) {
                    id = pc.template.list.indexOf(list[Math.floor(Math.random() * list.length)]);
                    pcFabricTemplateChange(id);
                }
                else {
                    alert("Can't find proper template for this image count.");
                    return;
                }
            }

            //random template fill

            //pcLoadingShow("Processing...");
            // pathList = pcFabricGetImageObjects();
            // pathCounter = 0;
            // setFill();

            // function setFill() {
            //     if (pathCounter === pathList.length) {
            //         pcLoadingHide();
            //         return;
            //     }

            //     let imageId = pathCounter;
            //     if (imageId >= pc.image.list.length)
            //         imageId = Math.floor(Math.random() * pc.image.list.length);

            //     pcFabricAddImage(
            //         pathList[pathCounter],
            //         $("#pcImage" + pc.image.list[imageId].id),
            //         function () {
            //             pathCounter++;
            //             setFill();
            //         }
            //     );
            // }
        }

        function pcFabricGetImageObjects() {
            let list = [];
            let objects = pc.fabric.mainCanvas._objects;

            for (let i = 0; i < objects.length; i++)
                if (objects[i].isType("path"))
                    list.push(objects[i]);

            return list;
        }

        function pcFabricGetOtherObjects() {
            let list = [];
            let objects = pc.fabric.mainCanvas._objects;

            for (let i = 0; i < objects.length; i++)
                if (!objects[i].isType("path"))
                    list.push(objects[i]);

            return list;
        }

        function pcFabricAddImage(path, imageWapper, callback = function () { }) {
            pc.cur.working = true;

            pcLoadingShow("Adding Image...");


            let imageId = parseInt($(imageWapper).parent().attr("id").replace("pcImage", ""));
            let pathId = pc.fabric.mainCanvas._objects.indexOf(path);

            if (pc.fabric.images[pathId] !== undefined) {
                let prevImageId = pc.fabric.images[pathId];
                pcImageUnuse($("#pcImage" + prevImageId));
            }

            pc.fabric.images[pathId] = imageId;
            pc.fabric.dim[pathId] = {
                scale: 1,
                offsetX: 0,
                offsetY: 0,
                movedX: 0,
                movedY: 0
            }

            pcImageUse(imageWapper);

            pcFabricFitImage(pathId, false, function () {
                pcLoadingHide();
                callback();
            });
        }

        function pcFabricZoom(value = null) {
            pc.cur.working = true;

            let path = pc.fabric.mainCanvas.getActiveObject();
            let pathIndex = pc.fabric.mainCanvas._objects.indexOf(path);

            if (path === null || !path.isType("path")) {
                alert("No Image Selected.")
                $(".pcImageOptionZoomInputSlider").val(0);
                $(".pcImageOptionZoomInputSliderPercent").html("0%");
                return;
            }

            let val;
            if (value === null) {
                val = $(".pcImageOptionZoomInputSlider").val();
            }
            else {
                val = value;
                $(".pcImageOptionZoomInputSlider").val(value)
            }

            $(".pcImageOptionZoomInputSliderPercent").html(Math.round((val * 100)) + "%");

            let zoomRatio = val * pc.def.zoomMax + 1;

            pc.fabric.dim[pathIndex].scale = zoomRatio;

            pcFabricFitImage(pathIndex);
        }

        function pcOptSyns() {
            pcOptSyncText();
            pcOptSyncImage();
        }

        function pcOptSyncImage() {
            pc.cur.working = true;

            let path = pc.fabric.mainCanvas.getActiveObject();

            $(".pcEditorRightImageOption").hide();

            if (path === null || path === undefined) {
                $(".pcImageOptionZoomInputSlider").val(0);
                $(".pcImageOptionZoomInputSliderPercent").html("0%");
                return;
            }

            if (!path.isType("path") || typeof path.fill === "string") {
                $(".pcImageOptionZoomInputSlider").val(0);
                $(".pcImageOptionZoomInputSliderPercent").html("0%");
                return;
            }

            //zoom sync
            let pathIndex = pc.fabric.mainCanvas._objects.indexOf(path);

            let val = pc.fabric.dim[pathIndex].scale - 1;

            $(".pcImageOptionZoomInputSlider").val(val);
            $(".pcImageOptionZoomInputSliderPercent").html(Math.round((val * 100)) + "%");

            //show menu
            $(".pcEditorRightImageOption").show();
        }


        function pcFabricBackgroundColor(val) {
            pc.cur.working = true;

            pcFabricBackgroundImageClear()

            pc.fabric.mainCanvas.setBackgroundColor(val, function () {
                pc.cur.backgroundColor = val;
                pc.fabric.mainCanvas.renderAll();
            });

        }

        function pcFabricBackgroundPattern(elm) {
            pc.cur.working = true;
            $(".pcEditorRightHeaderPattern").hide();

            pcFabricBackgroundImageClear()

            if ($(elm).attr("id") === "empty") {
                pc.fabric.mainCanvas.setBackgroundColor("#ffffff", function () {
                    pc.cur.backgroundColor = "#FFFFFF";
                    pc.fabric.mainCanvas.renderAll();
                });
                return;
            }

            pcLoadingShow();

            fabric.util.loadImage($(elm).attr("src"), function (img) {
                let pattern = new fabric.Pattern({ source: img });
                pc.fabric.mainCanvas.setBackgroundColor(pattern, function () {
                    pc.fabric.mainCanvas.renderAll();
                    pcLoadingHide();
                });
            });
        }

        function pcFabricBackgroundImageClear() {
            pc.cur.backgroundImage = "";
            pc.fabric.mainCanvas.setBackgroundImage(null);
            pc.fabric.mainCanvas.renderAll();
        }

        function pcFabricBackgroundImageUpdate(targetCanvas = pc.fabric.mainCanvas, callback = function () { }, CustomTemplateBackground) {

            if (pc.cur.backgroundImage === "") {
                pcFabricBackgroundImageClear();
                return;
            }

            if(CustomTemplateBackground != undefined && CustomTemplateBackground != null)
            {
                pc.cur.backgroundImage = CustomTemplateBackground;
            }

            pcLoadingShow();

            fabric.Image.fromURL(pc.cur.backgroundImage.replace("www.",""), function (img) {

                var image = new Image();
                image.crossOrigin = 'anonymous';
                image.src = pc.cur.backgroundImage.replace("www.","");

                image.onload = function () {
                    var imageRatio = image.width / image.height;
                    var fabricRatio = targetCanvas.width / targetCanvas.height;

                    var width = 0;
                    var height = 0;
                    var left = 0;
                    var top = 0;

                    if (imageRatio <= fabricRatio) {
                        width = targetCanvas.width;
                        height = targetCanvas.width / imageRatio;
                        top = - ((height - targetCanvas.height) / 2);
                    }
                    else {
                        height = targetCanvas.height;
                        width = targetCanvas.height * imageRatio;
                        left = - ((width - targetCanvas.width) / 2);
                    }

                    targetCanvas.setBackgroundImage(
                        img,
                        function () {
                            targetCanvas.renderAll();
                            pcLoadingHide();
                            callback();
                        },
                        {
                            scaleX: width / img.width,
                            scaleY: height / img.height,
                            top: top,
                            left: left
                        }
                    );
                }
            }, { crossOrigin: 'anonymous' });
        }

        function pcFabricBackgroundImageChange(file) {
            pc.cur.working = true;

            if (file.files.length > 1) {
                alert("Select just one image file.");
                return;
            }

            if (!file.files[0].type.match('image')) {
                alert(file.files[0].name + " is not image file.");
                return;
            }

            pc.fabric.mainCanvas.setBackgroundColor("#ffffff", function () {
                pc.cur.backgroundColor = "#ffffff";
                pc.fabric.mainCanvas.renderAll();
            });

            pcLoadingShow();

            let picReader = new FileReader();
            picReader.readAsDataURL(file.files[0]);

            picReader.onload = function () {
                pc.cur.backgroundImage = picReader.result;
                $(file).val("");

                pcLoadingHide();
                pcFabricBackgroundImageUpdate();
            }
        }

        function pcFabricTextAdd(text) {
            pc.cur.working = true;

            let textObject = new fabric.Textbox(text, {
                left: 100,
                top: 100,
                fill: "#000000",
                centeredRotation: true,
                objectCaching: false,
                cornerStyle: "circle",
                cornerSize: 8,
                borderColor: "#555555",
                cornerColor: "#053a31",
                cornerStrokeColor: "#053a31",
                fontSize: 20,
                fontFamily: "Fuzzy Bubbles"
            });

            textObject.setControlsVisibility({
                'tl': true,
                'tr': true,
                'br': true,
                'bl': true,
                'ml': true,
                'mr': true,
                'mt': true,
                'mb': true,
                'mtr': true
            });

            textObject.on("mousedown", function (e) {
                pcFabricFixControls(e);
            });

            pc.fabric.mainCanvas.add(textObject);
            pc.fabric.mainCanvas.setActiveObject(textObject);
            pcOptSyns();
            pc.fabric.mainCanvas.renderAll();

            alFabricTextFont();
        }

        function pcOptSyncText() {
            let object = pc.fabric.mainCanvas.getActiveObject();
            if (object === undefined || object === null) {
                //$(".pcEditorRightTextOption").hide();
                $(".pcTextOptionCover").show();
            }
            else if (object.type === "textbox") {
                // $("#pcTextOptionColor").val(object.fill);
                $("#pcTextOptionColorList").find(".active").removeClass("active");
                $("#pcTextOptionColorList").find("[data-color='" + object.fill + "']").addClass("active");

                if (object.fontFamily === "Times New Roman") {
                    // $("#pcTextOptionFont").val("Default");
                    $(".pcTextOptionFontList").find(".active").removeClass("active");
                    $(".pcTextOptionFontList").children().first().addClass("active");
                }
                else {
                    // $("#pcTextOptionFont").val(object.fontFamily);
                    $(".pcTextOptionFontList").find(".active").removeClass("active");
                    $(".pcTextOptionFontList").find("[data-font='" + object.fontFamily + "']")
                }
                //$(".pcEditorRightTextOption").show();
                $(".pcTextOptionCover").hide();
            }
            else {
                //$(".pcEditorRightTextOption").hide();
                $(".pcTextOptionCover").show();
            }
        }

        function alFabricTextColorListClick(elm) {
            if ($(elm).hasClass("active"))
                return;

            $(elm).parent().find(".active").removeClass("active");
            $(elm).addClass("active");

            alFabricTextColor();
        }

        function alFabricTextColor() {
            let object = pc.fabric.mainCanvas.getActiveObject();
            // object.fill = $("#pcTextOptionColor").val();
            object.fill = $("#pcTextOptionColorList").find(".active").attr("data-color");
            pc.fabric.mainCanvas.renderAll();
        }

        function alFabricTextFontListClick(elm) {
            if ($(elm).hasClass("active"))
                return;

            $(elm).parent().find(".active").removeClass("active");
            $(elm).addClass("active");

            alFabricTextFont();
        }

        function alFabricTextFont() {
            let object = pc.fabric.mainCanvas.getActiveObject();
            // let font = $("#pcTextOptionFont").val();
            let font = $("#pcTextOptionFontList").find(".active").attr("data-font");

            if (font === "Default") {
                object.set("fontFamily", "");
                pc.fabric.mainCanvas.requestRenderAll();
                return;
            }

            let myFont = new FontFaceObserver(font);
            pcLoadingShow("Loading Font...");
            myFont.load()
                .then(function () {
                    pcLoadingHide();
                    object.set("fontFamily", font);
                    pc.fabric.mainCanvas.requestRenderAll();
                })
                .catch(function (e) {
                    console.log(e)
                    alert('Font loading failed ' + font);
                    // $("#pcTextOptionFont").val("Default");
                    $(".pcTextOptionFontList").find(".active").removeClass("active");
                    $(".pcTextOptionFontList").children().first().addClass("active");
                    pcLoadingHide();
                }
                );
        }

        function alFabricTextFontSizeListClick(elm) {
            var object = pc.fabric.mainCanvas.getActiveObject();
            var fontSize = $(elm).attr("data-fontSize");

            object.set("fontSize", fontSize);
            pc.fabric.mainCanvas.requestRenderAll();
        }

        function pcFabricImageRemove() {
            var object = pc.fabric.mainCanvas.getActiveObject();

            if (object == undefined && object == null) {
                return;
            }
            else if (!object.isType("path")) {
                pc.fabric.mainCanvas.remove(object);
                object.set({
                    hasControls: false
                })

                pc.fabric.mainCanvas.renderAll();
                return;
            }

            pc.cur.working = true;

            let objId = pc.fabric.mainCanvas._objects.indexOf(object);

            pcImageUnuse($("#pcImage" + pc.fabric.images[objId]));

            // pc.fabric.images.splice(objId, 1);
            pc.fabric.images[objId] = undefined;
            object.set("fill", "#eeeeee");

            object.set({
                hasControls: false
            })

            pc.fabric.mainCanvas.renderAll();
        }

        function pcFabricMoveImage(e) {
            pc.cur.working = true;

            if (pc.cur.loadingShow)
                return;

            if (!$(".pcEditor").is(":visible"))
                return;

            if (pc.cur.dragStart === -1 || pc.cur.drag === false)
                return;

            var path = pc.cur.dragStart.target;
            if (path === undefined || path === null)
                return;
            if (!pc.fabric.mainCanvas.getActiveObject().isType("path"))
                return;

            var pathIndex = pc.fabric.mainCanvas._objects.indexOf(path);

            var dragX = e.e.clientX - pc.cur.dragStart.e.clientX;
            var dragY = e.e.clientY - pc.cur.dragStart.e.clientY;

            pc.fabric.dim[pathIndex].movedX = dragX + pc.fabric.dim[pathIndex].movedXLast;
            pc.fabric.dim[pathIndex].movedY = dragY + pc.fabric.dim[pathIndex].movedYLast;

            pcFabricFitImage(pathIndex);
        }

        function pcFabricFitImage(pathId, useMainPic = false, callback = function () { }) {
            pc.cur.working = true;

            if (pc.fabric.images[pathId] === undefined) {
                callback();
                return;
            }

            let imageId = pc.image.list.findIndex(item => item.id === pc.fabric.images[pathId]);

            let imageSrc = pc.image.list[imageId].thumbSrc;
            if (useMainPic)
                imageSrc = pc.image.list[imageId].src;

            fabric.Image.fromURL(imageSrc, function (img) {

                let path = pc.fabric.mainCanvas._objects[pathId];

                let pathWidth = path.width * pc.fabric.dim[pathId].scale;
                let pathHeight = path.height * pc.fabric.dim[pathId].scale;
                let pathRatio = pathWidth / pathHeight;

                let imgWidth = img.width;
                let imgHeight = img.height;
                let imgRatio = imgWidth / imgHeight;

                let offsetX = 0;
                let offsetY = 0;

                let movedX = pc.fabric.dim[pathId].movedX;
                let movedY = pc.fabric.dim[pathId].movedY;

                let left = 0;
                let top = 0;

                if (imgRatio <= pathRatio) {
                    img.scaleToWidth(pathWidth);
                    offsetX = - (pathWidth - path.width) / 2;
                    offsetY = - (((imgHeight * (pathWidth / imgWidth)) - pathHeight) / 2) - (pathHeight - path.height) / 2;
                }
                else {
                    img.scaleToHeight(pathHeight);
                    offsetX = - (((imgWidth * (pathHeight / imgHeight)) - pathWidth) / 2) - (pathWidth - path.width) / 2;
                    offsetY = - (pathHeight - path.height) / 2;
                }

                left = offsetX + movedX;
                if (left > 0)
                    left = 0;
                else if ((- left) + path.width > img.getScaledWidth())
                    left = path.width - img.getScaledWidth();

                top = offsetY + movedY;
                if (top > 0)
                    top = 0;
                else if ((- top) + path.height > img.getScaledHeight())
                    top = path.height - img.getScaledHeight();

                let patternSourceCanvas = new fabric.StaticCanvas();
                patternSourceCanvas.add(img);
                patternSourceCanvas.setDimensions({
                    width: img.getScaledWidth(),
                    height: img.getScaledHeight(),
                });

                let imageId = pc.image.list.findIndex(item => item.id === pc.fabric.images[pathId]);
                let filters = pc.image.list[imageId].filters.slice();
                if (filters.length > 0)
                    if (filters[0].mainParameter === undefined)
                        filters[0] = new fabric.Image.filters.Grayscale();
                patternSourceCanvas._objects[0].filters = filters;
                patternSourceCanvas._objects[0].applyFilters();

                patternSourceCanvas.renderAll();

                let pattern = new fabric.Pattern({
                    source: patternSourceCanvas.getElement(),
                    repeat: 'no-repeat',
                    offsetX: left,
                    offsetY: top
                });

                path.set('fill', pattern);

                path.set({
                    hasControls: true
                })

                path.setControlsVisibility({
                    'tl': false,
                    'tr': false,
                    'br': false,
                    'bl': false,
                    'ml': false,
                    'mr': false,
                    'mt': false,
                    'mb': false,
                    'mtr': false
                });

                pc.fabric.dim[pathId].offsetX = offsetX;
                pc.fabric.dim[pathId].offsetY = offsetY;

                patternSourceCanvas.renderAll();
                pc.fabric.mainCanvas.renderAll();

                callback();
            });
        }

        function pcImageUse(imageWapper) {
            let imageId = parseInt($(imageWapper).parent().attr("id").replace("pcImage", ""));

            pc.image.list[pc.image.list.findIndex(item => item.id === imageId)].usage++;

            pcImageUpdateList();
        }

        function pcImageUnuse(imageWapper) {
            let imageId = parseInt($(imageWapper).attr("id").replace("pcImage", ""));
            pc.image.list[pc.image.list.findIndex(item => item.id === imageId)].usage--;

            pcImageUpdateList();
        }


        function pcExit() {
            if (pc.cur.working)
                return "You have attempted to leave this page. Are you sure?";
            else
                return;
        }

        function pcPreviewShow() {
            pcLoadingShow("Processing...");
            let image = new Image();
            image.src = pc.fabric.mainCanvas.toDataURL();
            image.onload = function () {
                $("#pcPreview").attr("src", image.src);
                pcLoadingHide();
                $(".pcPreview").show();
            }
        }

        function pcPreviewHide() {
            $(".pcPreview").hide();
        }

        function pcProjectOpenList() {
            let userId = $("#photoCollageUserId").html();
            if (userId == 0) {
                $(".xoo-el-action-sc").attr("data-redirect", location.protocol + '//' + location.host + location.pathname + "?action=openList");
                $(".xoo-el-action-sc")[0].click();
                return;
            }

            $(".pcOpenList").html("");

            pcLoadingShow("Processing ...");

            $.ajax({
                url: pc.def.serverSidePath + "/openJson.php",
                method: "POST",
                data: {
                    userId: userId
                },
                success: function (data) {
                    pcLoadingHide();

                    if (data === "") {
                        alert("You do not have a saved project.");
                    }
                    else {
                        data = data.split("\n");
                        for (let i = 0; i < data.length - 1; i++) {
                            data[i] = data[i].replace("photoCollageSaves/", "");
                            data[i] = data[i].replace(".json", "");
                            data[i] = data[i].replace(userId + "-", "");
                            $(".pcOpenList").append(
                                "<div><div class='pcOpenName'>" + data[i] + "</div><div class='pcOpenDelete'>X</div></div>"
                            );
                        }

                        $(".pcOpen").show();
                    }
                },
                error: function (data) {
                    pcLoadingHide();
                    alert(data);
                }
            })
        }

        function pcProjectCloseList() {
            $(".pcOpen").hide();
        }

        function pcProjectSave(tempFile = null) {
            if (!pc.cur.working && tempFile === null)
                return;

            pcLoadingShow("processing...");

            let userId = $("#photoCollageUserId").html();
            let name = "";
            let overwrite = 1;
            let saveTemp = 0;
            let data = "";

            //save temp file
            if (tempFile !== null) {
                if (userId === 0) {
                    location.href = location.protocol + '//' + location.host + location.pathname;
                    return;
                }

                $.getJSON(pc.def.serverSidePath + "photoCollageSaves/" + tempFile, function (response) {
                    data = response;
                    resume();
                });

                $.ajax({
                    url: pc.def.serverSidePath + "/deleteJson.php",
                    method: "POST",
                    data: {
                        name: tempFile,
                        temp: 1
                    }
                })

                return;
            }

            if (userId == 0) {
                saveTemp = 1;
            }
            else {
                name = pc.cur.projectName;
                if (name === "" || name === null) {
                    name = prompt("Please enter name of your project : ", "Untitled Project");
                    pc.cur.projectName = name;
                    overwrite = 0;
                }

                if (name === null) {
                    pcLoadingHide();
                    return;
                }
            }

            //save images

            if (pc.image.list.length > 0) {
                let imageCounter = 0;
                let imageId = [];
                let imageList = [];
                uploadImage();

                function uploadImage() {
                    if (imageCounter > pc.image.list.length - 1) {
                        if (imageList.length > 0)
                            resumeUpload();
                        else
                            resume();
                    }
                    else {
                        if (pc.image.list[imageCounter].src.length < 300) {
                            imageCounter++;
                            uploadImage()
                        }
                        else {
                            imageId.push(imageCounter);
                            imageList.push(pc.image.list[imageCounter].src);
                            imageList.push(pc.image.list[imageCounter].thumbSrc);
                            imageCounter++;
                            uploadImage();
                        }
                    }
                }

                function resumeUpload() {
                    canadaUploader(
                        imageList,
                        "photoCollageSave",
                        "jpeg",
                        function (response) {
                            response = response.split("\n");
                            for (let i = 0; i < imageId.length; i++) {
                                pc.image.list[imageId[i]].src = response[(2 * i)];
                                pc.image.list[imageId[i]].thumbSrc = response[(2 * i) + 1];
                            }
                            $("#vancouverUploadCover").hide();

                            resume();
                        },
                        false
                    )
                }
            }
            else {
                resume();
            }

            function resume() {
                if (pc.cur.backgroundImage === "") {
                    resume2();
                    return;
                }

                canadaUploader(
                    [pc.cur.backgroundImage],
                    "photoCollageSave",
                    "jpeg",
                    function (response) {
                        pc.cur.backgroundImage = response;
                        resume2();
                    },
                    false
                )
            }

            function resume2() {
                if (tempFile === null) {
                    data = {
                        image: {
                            list: pc.image.list.slice()
                        },
                        cur: pc.cur,
                        fabric: {
                            images: pc.fabric.images,
                            dim: pc.fabric.dim,
                        }
                    };

                }
                else {
                    name = tempFile.replace(".json", "").split("-")[2];
                    if (name === "") {
                        name = prompt("Please enter name of your project : ", "Untitled Project");
                        pc.cur.projectName = name;
                        overwrite = 0;
                    }

                    if (name === null)
                        return;
                }

                saveJson();

                function saveJson() {
                    pc.cur.otherObj = pcFabricGetOtherObjects();
                    $.ajax({
                        url: pc.def.serverSidePath + "/saveJson.php",
                        method: "POST",
                        data: {
                            data: JSON.stringify(data),
                            userId: userId,
                            name: name,
                            overwrite: overwrite,
                            saveTemp: saveTemp
                        },
                        success: function (data) {
                            if (data === "duplicate") {
                                name = prompt("Your chosen name is duplicate.\nPlease select a new name : ", "Untitled Project");
                                saveJson();
                            }
                            else if (data === "new") {
                                name = prompt("Please enter name of your project : ", "Untitled Project");
                                saveJson();
                            }
                            else if (data.startsWith("temp")) {
                                pc.cur.working = false;
                                $(".xoo-el-action-sc").attr("data-redirect", location.protocol + '//' + location.host + location.pathname + "?tempFile=" + data)
                                $(".xoo-el-action-sc")[0].click();
                                return;
                            }
                            else {
                                if (tempFile !== null) {
                                    pc.cur.working = false;
                                    alert(data);
                                    location.href = location.protocol + '//' + location.host + location.pathname + "?project=" + encodeURIComponent(name);
                                }
                                else {
                                    pc.cur.projectName = name;
                                    pc.cur.working = false;
                                    alert(data);
                                    location.href = location.protocol + '//' + location.host + location.pathname + "?project=" + encodeURIComponent(name);
                                }
                            }
                        },
                        error: function (data) {
                            pcLoadingHide();
                            alert(data);
                        }
                    })
                }
            }
        }

        function pcProjectSaveTemplate() {
            if (!pc.cur.working)
                return;

            pcLoadingShow("processing...");

            var data = Object.assign({}, pc);
            data.image.list = [];
            data.image.id = 0;
            data.fabric.images = [];



            //save background
            if (data.cur.backgroundImage === "") {
                resume();
            }
            else {
                canadaUploader(
                    [data.cur.backgroundImage],
                    "photoCollageTemplateBackground",
                    "jpeg",
                    function (response) {
                        data.cur.backgroundImage = response;
                        $("#vancouverUploadCover").hide();
                        resume();
                    },
                    false
                )
            }

            // //save thumbnail
            // function resume(){
            //     var base64String = data.fabric.mainCanvas.toDataURL({
            //         format: 'jpeg',
            //         multiplier: 0.5,
            //         quality:0.8
            //     });
            //     canadaUploader(
            //         [base64String],
            //         "photoCollageTemplateThumb",
            //         "jpeg",
            //         function (response) {
            //             data.cur.templateThumb = response;
            //             $("#vancouverUploadCover").hide();
            //             resume2();
            //         },
            //         false
            //     )
            // }

            function resume() {
                var name = prompt("Please enter template name : ", "Template");

                var base64String = data.fabric.mainCanvas.toDataURL({
                    format: 'jpeg',
                    multiplier: 0.5,
                    quality: 0.8
                });

                var current = Object.assign({}, data.cur);
                current.dragStart = -1;

                var dataToSend = {
                    cur: current
                }

                saveJson();

                function saveJson() {
                    data.cur.otherObj = pcFabricGetOtherObjects();
                    $.ajax({
                        url: data.def.serverSidePath + "/saveTemplateJson.php",
                        method: "POST",
                        data: {
                            data: JSON.stringify(dataToSend),
                            name: produceName(name),
                            thumb: base64String
                        },
                        success: function (response) {
                            if (response === "duplicate") {
                                name = prompt("Your chosen name is duplicate.\nPlease select a new name : ", "Template");
                                saveJson();
                            }
                            else {
                                pcLoadingHide();
                                alert(response);
                            }
                        },
                        error: function (response) {
                            pcLoadingHide();
                            var err = JSON.parse(response.responseText).form_error.__all__.join("\n");
                            alert(err);
                        }
                    })
                }
            }

            function produceName(n) {
                return n + "-" + data.cur.templateOri + "-" + data.cur.template.objects.length;
            }
        }

        function pcProjectRestore(name) {
            let userId = $("#photoCollageUserId").html();
            if (userId == 0) {
                $(".xoo-el-action-sc")[0].click();
                return;
            }

            pcLoadingShow("Processing...");

            $.getJSON(pc.def.serverSidePath + "/photoCollageSaves/" + userId + "-" + name + ".json", function (data) {

                pc.cur = Object.assign({}, data.cur);
                temId = pc.template.list.findIndex(item => item.src === pc.cur.templateSrc);
                pcFabricTemplateChange(temId, false, true);

                pc.cur = Object.assign({}, data.cur);
                pc.image.list = data.image.list;
                pc.fabric.images = data.fabric.images;
                pc.fabric.dim = data.fabric.dim;

                pcFabricBackgroundImageUpdate();
                pcImageUpdateList(false);
                pcFabricRefresh();
                pcProjectNameSync();
            });
        }

        function pcProjectNameSync() {
            if (pc.cur.projectName === "")
                $("#pcEditorRightHeaderName").find("div").html("Project Name : Unsaved");
            else
                $("#pcEditorRightHeaderName").find("div").html("Project Name : " + pc.cur.projectName);

        }

        function pcProjecNew() {
            pcLoadingShow("Processing...");
            location.href = location.protocol + '//' + location.host + location.pathname;
        }

        function pcProjectDelete(elm) {
            if (!confirm("Are you sure you want to delete this project?"))
                return;

            let userId = $("#photoCollageUserId").html();
            if (userId == 0) {
                $(".xoo-el-action-sc")[0].click();
                return;
            }

            pcLoadingShow("Processing ...");

            $.ajax({
                url: pc.def.serverSidePath + "/deleteJson.php",
                method: "POST",
                data: {
                    userId: userId,
                    name: $(elm).parent().find(".pcOpenName").html(),
                    temp: 0
                },
                success: function (data) {
                    pcLoadingHide();
                    if (data) {
                        pcProjectOpenList();
                    }
                    else {
                        alert(data);
                    }
                },
                error: function (data) {
                    pcLoadingHide();
                    alert(data);
                }
            })
        }

        function pcProjectOpen(elm) {
            pcLoadingShow("Processing...");
            pc.cur.working = false;;
            location.href = location.protocol + '//' + location.host + location.pathname + "?project=" + encodeURIComponent($(elm).html());
        }

        function pcFinishClick() {

            pcLoadingShow("Processing...");
            pcFinishListUpdate();

            pcFinishImageUpdate(function () {
                $(".pcEditor").hide();
                $(".pcFinish").show();
                pcLoadingHide();
            });
        }

        function pcFinishImageUpdate(callback = function () { }) {
            let image = new Image();
            image.src = pc.fabric.mainCanvas.toDataURL();
            image.onload = function () {
                $("#pcShowCollageImg").attr("src", image.src);
                callback();
            }
        }

        function pcFinishImageSizeUpdate() {
            let size = $("#pcFinishOptionSize").find(".pcFinishOptionRowActive").children().first().html();
            if(size == undefined)
            {
                return;
            }
            size = size.replace("  inch", "");
            size = size.split(" — ");

            $(".pcShowCollageTopText").html(size[0] + " inch");
            $(".pcShowCollageRightText").html(size[1] + " inch");

            $(".pcMainEditAreaTopText").html(size[0] + " inch");
            $(".pcMainEditAreaRightText").html(size[1] + " inch");
        }

        function pcFinishListUpdate() {
            let type = $("#pcFinishOptionType").val();
            let ori = pc.cur.templateOri;

            //size list
            $("#pcFinishOptionSize").html("");

            let sizeList = pc.finish.sizes[type].filter(item => item.ori === ori);
            sizeList.forEach(function (item, i) {
                let activeClass = "";
                if (i === 0)
                    activeClass = "pcFinishOptionRowActive";

                $("#pcFinishOptionSize").append(
                    '<div class="pcFinishOptionRow clearBoth ' + activeClass + '" id="size' + i + '">' +
                    '<div>' + pcSizeGetView(item.size) + '</div>' +
                    '<div>' + item.price + '$</div>' +
                    '</div>'
                );
            });

            //option list

            $("#pcFinishOptionTitle").html("");
            $("#pcFinishOptionFrame").html("");

            if (pc.finish.optionTitle[type] !== "") {
                $("#pcFinishOptionTitle").html(pc.finish.optionTitle[type] + " :");

                pc.finish.options[type].forEach(function (item, i) {
                    let activeClass = "";
                    if (i === 0)
                        activeClass = "pcFinishOptionRowActive";

                    $("#pcFinishOptionFrame").append(
                        '<div class="pcFinishOptionRow clearBoth ' + activeClass + '" id="option' + i + '">' +
                        '<div>' + item.title + '</div>' +
                        '<div>' + item.price + '</div>' +
                        '</div>'
                    );
                });
            }

            pcFinishImageSizeUpdate();
            pcFinishTotalPriceUpdate();
        }

        function pcFinishListSelect(elm) {
            if ($(this).hasClass("pcFinishOptionRowActive"))
                return;

            $(elm).parent().find(".pcFinishOptionRowActive").removeClass("pcFinishOptionRowActive");
            $(elm).addClass("pcFinishOptionRowActive");

            pcFinishImageSizeUpdate();
            pcFinishTotalPriceUpdate();
        }

        function pcFinishTotalPriceUpdate() {
            let type = $("#pcFinishOptionType").val();

            let sizePrice = $("#pcFinishOptionSize").find(".pcFinishOptionRowActive").children().last().html();
            sizePrice = parseFloat(sizePrice);

            let optionPrice = $("#pcFinishOptionFrame").find(".pcFinishOptionRowActive").children().last().html();
            optionPrice = parseFloat(optionPrice);

            if (isNaN(optionPrice))
                optionPrice = 0;

            let quantity = parseInt($(".pcFinishOptionCountValue").html());
            $(".pcTotalPrice").html("Total Price : " + ((sizePrice + optionPrice) * quantity).toFixed(2) + "$");
        }

        function pcFinishQuantity(elm) {
            let className = $(elm).attr("class");
            let trg = $(elm).parent();
            if (className === "pcFinishOptionCountPlus") {
                let ctn = parseInt($(trg).find(".pcFinishOptionCountValue").html()) + 1;
                $(trg).find(".pcFinishOptionCountValue").html(ctn);
            }
            else if (className === "pcFinishOptionCountMines") {
                let ctn = parseInt($(trg).find(".pcFinishOptionCountValue").html()) - 1;
                if (ctn >= 1)
                    $(trg).find(".pcFinishOptionCountValue").html(ctn);
            }
            else if (className === "pcFinishOption clearBoth") {
                let ctn = parseInt($(elm).find(".pcFinishOptionCountValue").html());
                if (ctn === 1)
                    $(elm).find(".pcFinishOptionCountValue").html("1");
            }

            pcFinishImageSizeUpdate();
            pcFinishTotalPriceUpdate();
        }

        function pcSizeGetView(size) {
            size = size.split("-");
            return size[0] + ' — ' + size[1] + '  inch';
        }

        function pcFinishBackToEditor() {
            $(".pcFinish").hide();
            $(".pcEditor").show();
        }

        function pcAddToCard() {
            pcLoadingShow("Processing ...")
            // if(!confirm("Do you really finish your design?"))
            //     return;

            if (pc.fabric.mainCanvas === "")
                return;

            //get defults

            let type = $("#pcFinishOptionType").val();
            let ori = pc.cur.templateOri;

            let sizeId = $("#pcFinishOptionSize").find(".pcFinishOptionRowActive").attr("id").replace("size", "");
            let size = pc.finish.sizes[type].filter(item => item.ori === ori)[sizeId].size;
            let sizePrice = parseFloat(pc.finish.sizes[type][sizeId].price);

            let exportWidth = parseInt(size.split('-')[0]) * pc.def.dpi;
            let multiplier = exportWidth / pc.fabric.mainCanvas.width;

            let quantity = parseInt($(".pcFinishOptionCountValue").html());

            let option = "";
            let optionPrice = 0;
            if (pc.finish.optionTitle[type] !== "") {
                let optionId = $("#pcFinishOptionFrame").find(".pcFinishOptionRowActive").attr("id").replace("option", "");
                option = pc.finish.options[type][optionId].title;
                optionPrice = parseFloat(pc.finish.options[type][optionId].price);
            }

            let totalPrice = ((sizePrice + optionPrice) * quantity).toFixed(2);

            //start upload

            pcExport(multiplier, function (result) {
                // $(".photoCollage").append("<img src='" + result + "' width='200' />")

                pcLoadingHide();
                canadaUploader
                    (
                        [result],
                        'photoCollage',
                        'jpeg',
                        function (response) {
    pc.cur.working = false;

    var formData = new FormData();

    formData.append("order_url", response);
    formData.append("order_type", type);      // Canvas / Paper / Metal
    formData.append("order_size", size);
    formData.append("order_option", option);
    formData.append("order_quantity", quantity);
    formData.append("price", totalPrice);
    formData.append("title", "Photo Collages");

    // lowercase to match PHP mapping
    formData.append("product_type", "PhotoCollage");  

    // first image URL (in case of multiple uploads)
    formData.append("image_url", response.split('\n')[0].trim());

    $.ajax({
        url: "https://canadaphotolab.com/wp-content/themes/printspace/shopify/create_draft_order.php",
        method: "POST",
        data: formData,
        contentType: false,
        processData: false,
        dataType: "json",
        success: function (response) {
            if (response.success) {
                window.location.href = response.url;
            } else {
                alert("Error: " + (response.message || "Something went wrong"));
                console.log(response);
            }
        },
        error: function (xhr, status, error) {
            alert("AJAX error: " + xhr.responseText + " " + status + " " + error);
            console.log(xhr.responseText);
        },
    });
}

                    );
            });
        }

        function pcExport(scale, callBack = function (result) { }) {
            //create fabric
            let canvas = $("#pcExport").get(0);

            canvas.width = pc.fabric.mainCanvas.getWidth();
            canvas.height = pc.fabric.mainCanvas.getHeight();

            canvas.width *= scale;
            canvas.height *= scale;

            pc.fabric.exportCanvas = new fabric.Canvas('pcExport');
            pc.fabric.exportCanvas.set({
                uniScaleTransform: false,
                enableRetinaScaling: true,
                uniScaleKey: "none",
                selection: false,
                containerClass: "pcExportArea",
                controlsAboveOverlay: true,
                backgroundColor: "#ffffff",
                perPixelTargetFind: false
            });
            pc.fabric.exportCanvas.backgroundColor.repeat = 'repeat';
            pc.fabric.exportCanvas.renderAll();

            //clean canvas
            for (let i = pc.fabric.exportCanvas._objects.length - 1; i >= 0; i--) {
                pc.fabric.exportCanvas.remove(pc.fabric.exportCanvas._objects[i]);
            }

            //set page objects
            let images = pc.fabric.images.slice();
            let objects = pc.fabric.mainCanvas._objects.slice();
            let counter = 0;
            addObject();

            function addObject() {
                if (counter === objects.length) {
                    resume();
                    return;
                }
                insertObject(objects[counter], counter, function () {
                    counter++;
                    addObject();
                })
            }

            //insert object to canvas
            function insertObject(obj, objId, callback = function () { }) {
                if (obj.isType("path")) {
                    //add path

                    obj.path.forEach(function (item, i) {
                        item.forEach(function (item2, i2) {
                            if (Number(item2) === item2)
                                obj.path[i][i2] = item2 * (scale * obj.scaleX);
                        });
                    });

                    let path = new fabric.Path(obj.path);

                    path.set({
                        fill: "#eeeeee",
                        left: obj.left * (scale),
                        top: obj.top * (scale),
                        lockMovementX: true,
                        lockMovementY: true,
                        hasControls: false,
                        borderColor: "#053a31"
                    })

                    pc.fabric.exportCanvas.add(path);
                    pc.fabric.exportCanvas.renderAll();


                    //add image
                    if (images.length === 0) {
                        callback();
                        return;
                    }
                    else if (images[objId] === undefined) {
                        callback();
                        return;
                    }

                    let imageSrc = pc.image.list[images[objId]].src;

                    fabric.Image.fromURL(imageSrc, function (img) {

                        let path = pc.fabric.exportCanvas._objects[objId];

                        let pathWidth = path.width * pc.fabric.dim[objId].scale;
                        let pathHeight = path.height * pc.fabric.dim[objId].scale;
                        let pathRatio = pathWidth / pathHeight;

                        let imgWidth = img.width;
                        let imgHeight = img.height;
                        let imgRatio = imgWidth / imgHeight;

                        let offsetX = 0;
                        let offsetY = 0;

                        let movedX = pc.fabric.dim[objId].movedX;
                        let movedY = pc.fabric.dim[objId].movedY;

                        let left = 0;
                        let top = 0;

                        if (imgRatio <= pathRatio) {
                            img.scaleToWidth(pathWidth);
                            offsetX = - (pathWidth - path.width) / 2;
                            offsetY = - (((imgHeight * (pathWidth / imgWidth)) - pathHeight) / 2) - (pathHeight - path.height) / 2;
                        }
                        else {
                            img.scaleToHeight(pathHeight);
                            offsetX = - (((imgWidth * (pathHeight / imgHeight)) - pathWidth) / 2) - (pathWidth - path.width) / 2;
                            offsetY = - (pathHeight - path.height) / 2;
                        }

                        left = offsetX + movedX;
                        if (left > 0)
                            left = 0;
                        else if ((- left) + path.width > img.getScaledWidth())
                            left = path.width - img.getScaledWidth();

                        top = offsetY + movedY;
                        if (top > 0)
                            top = 0;
                        else if ((- top) + path.height > img.getScaledHeight())
                            top = path.height - img.getScaledHeight();

                        let patternSourceCanvas = new fabric.StaticCanvas();
                        patternSourceCanvas.add(img);
                        patternSourceCanvas.setDimensions({
                            width: img.getScaledWidth(),
                            height: img.getScaledHeight(),
                        });

                        let imageId = pc.image.list.findIndex(item => item.id === pc.fabric.images[objId]);
                        let filters = pc.image.list[imageId].filters.slice();
                        patternSourceCanvas._objects[0].filters = filters;
                        patternSourceCanvas._objects[0].applyFilters();

                        patternSourceCanvas.renderAll();

                        let pattern = new fabric.Pattern({
                            source: patternSourceCanvas.getElement(),
                            repeat: 'no-repeat',
                            offsetX: left,
                            offsetY: top
                        });

                        path.set('fill', pattern);

                        pc.fabric.dim[objId].offsetX = offsetX;
                        pc.fabric.dim[objId].offsetY = offsetY;

                        patternSourceCanvas.renderAll();
                        pc.fabric.mainCanvas.renderAll();

                        callback();
                    });
                }
                else {
                    obj.clone(function (clonedObj) {
                        clonedObj.left *= scale;
                        clonedObj.top *= scale;
                        clonedObj.width *= scale;
                        clonedObj.height *= scale;
                        clonedObj.fontSize *= scale;
                        pc.fabric.exportCanvas.add(clonedObj);
                        pc.fabric.exportCanvas.renderAll();

                        callback();
                    })

                }
            }

            //set page background
            function resume() {
                //background image
                if (pc.cur.backgroundImage === "") {
                    pc.fabric.exportCanvas.setBackgroundImage(null);
                    pc.fabric.exportCanvas.renderAll();

                    pc.fabric.exportCanvas.setBackgroundColor(pc.fabric.mainCanvas.backgroundColor, function () {
                        pc.fabric.exportCanvas.renderAll();
                        resume2();
                    });
                }
                else {
                    pcFabricBackgroundImageUpdate(pc.fabric.exportCanvas, function () {
                        resume2();
                    });
                }
            }

            //resume to export
            function resume2() {
                callBack(
                    changeDpiDataUrl(
                        pc.fabric.exportCanvas.toDataURL({ format: 'jpeg' }),
                        pc.def.dpi
                    )
                );
            }

        }

        function pcTemplateChange(elm) {
            var templateId = $(elm).parent().parent().attr("id").replace("template", "");
            var templateType = $(elm).parent().parent().attr("data-type");

            if (templateType === "svg") {
                pcFabricTemplateChange(templateId);
                pcTemplateHide();
            }
            else if (templateType === "json") {
                pcTemplateRestore(templateId);
                pcTemplateHide();
            }
        }

        function pcTemplateRestore(id) {
            pcLoadingShow("Processing...");

            tem = pc.template.list[id];

            $.getJSON(pc.def.serverSidePath + "/photoCollageTemplateSaves/" + tem.fullName + ".json?ver=2", function (data) {

                pc.cur = Object.assign({}, data.cur);
                temId = pc.template.list.findIndex(item => item.src === pc.cur.templateSrc);
                pcFabricTemplateChange(temId, false, true);

                pc.cur = Object.assign({}, data.cur);
                //pc.image.list = data.image.list;
                //pc.fabric.images = data.fabric.images;
                //pc.fabric.dim = data.fabric.dim;

                pcFabricBackgroundImageUpdate(undefined,undefined,tem.backgroundImage);
                pcImageUpdateList(false);
                pcFabricRefresh();
                pcProjectNameSync();
            });
        }

        function pcTemplateUpdateList() {
            $(".pcTemplateList").html("");
            let tempCat = $(".pcTemplateCatList").find(".pcTemplateCatActive").attr("data-cat");

            // var sortKey = "name";
            // pc.template.list.sort((a, b) => (a[sortKey] > b[sortKey]) ? 1 : ((b[sortKey] > a[sortKey]) ? -1 : 0));

            for (let i = 0; i < pc.template.list.length; i++) {
                let tem = pc.template.list[i];

                if (tem.type === "svg") {
                    if (tempCat !== "all") {
                        if (pc.cat[tempCat].indexOf(tem.name + "-" + tem.ori) === -1) {
                            continue;
                        }
                    }

                    if (tem.thumbSrc !== "404" || pc.cur.mode == "addTemplate") {
                        $(".pcTemplateList").append(
                            '<div class="clearBoth" id="template' + i + '" data-type="' + tem.type + '" >' +
                            '<div class="pcTemplateThumb">' +
                            '<img src="' + tem.thumbSrc + '?ver=' + pc.def.templateVersion + '" />' +
                            '</div>' +
                            '<div class="pcTemplateDesc">' +
                            '<div class="pcTemplateDescTitle">' + tem.name + '</div>' +
                            // '<div class="pcTemplateDescCount">' + tem.objects.length + ' Pictures</div>' +
                            '<div class="pcTemplateDescType">' + tem.ori + '</div>' +
                            '<div class="pcTemplateCreate">Create Collage</div>' +
                            '</div>' +
                            '</div>'
                        )
                    }
                }
                if (tem.type === "json") {
                    if (tempCat !== "all") {
                        if (pc.cat[tempCat].indexOf(tem.name) === -1) {
                            continue;
                        }
                    }


                    $(".pcTemplateList").append(
                        '<div class="clearBoth" id="template' + i + '" data-type="' + tem.type + '" >' +
                        '<div class="pcTemplateThumb">' +
                        '<img src="' + tem.thumbSrc + '?ver=' + pc.def.templateVersion + '" />' +
                        '</div>' +
                        '<div class="pcTemplateDesc">' +
                        '<div class="pcTemplateDescTitle">' + tem.name + '</div>' +
                        '<div class="pcTemplateDescCount">' + tem.count + ' Pictures</div>' +
                        '<div class="pcTemplateDescType">' + tem.ori + '</div>' +
                        '<div class="pcTemplateCreate">Create Collage</div>' +
                        '</div>' +
                        '</div>'
                    )

                }
            }
        }

        function pcCatgoryClick(elm) {
            $(elm).parent().find(".pcTemplateCatActive").removeClass("pcTemplateCatActive");
            $(elm).addClass("pcTemplateCatActive");
            pcTemplateUpdateList();
        }

        //Actions

        window.onbeforeunload = pcExit;

        $("#pcEditorRightHeaderBackgroundImage").click(function () {
            $(".photoCollage").find("#backgroundImage").click();
        })

        $(".photoCollage").on("change", "#backgroundImage", function () {
            pcFabricBackgroundImageChange(this);
        })

        $(".pcTemplateCatList").on('click', '>div', function () {
            pcCatgoryClick($(this));
        });
        $(".pcAddToCard").click(function () {
            pcAddToCard();
        });

        $(".pcBackToEditor").click(function () {
            pcFinishBackToEditor();
        });

        $(".pcFinishOptionCount").on('click', '.pcFinishOptionCountMines,.pcFinishOptionCountPlus', function () {
            pcFinishQuantity($(this));
        });

        $(".pcFinishOptions").on("click", ".pcFinishOptionRow", function () {
            pcFinishListSelect(this)
        });

        $("#pcFinishOptionType").on("change", function () {
            pcFinishListUpdate();
        });

        $(".pcEditorLeftFinish").click(function () {
            pcFinishClick();
        });

        $(".pcOpenList").on("click", ">div>.pcOpenDelete", function () {
            pcProjectDelete(this);
        })

        $(".pcOpenList").on("click", ">div>.pcOpenName", function () {
            pcProjectOpen(this);
        })

        $("#pcEditorRightHeaderSave").click(function () {
            pcProjectSave();
        });

        $(".pcOpenExitBtn").click(function () {
            pcProjectCloseList();
        });

        $("#pcEditorRightHeaderOpen").click(function () {
            pcProjectOpenList();
        });

        $(".pcOpenExitBtn").click(function () {
            pcProjectCloseList();
        });

        $(".pcEditorLeftFuncsPreview").click(function () {
            pcPreviewShow();
        });

        $(".pcPreviewClose").click(function () {
            pcPreviewHide();
        });

        $(".pcImageOptionZoomInputSlider").on("input", function () {
            pcFabricZoom();
        })

        // $("#pcTextOptionColor").on("input",function () {
        //     alFabricTextColor();
        // });

        $("#pcTextOptionColorList").on("click", ">div", function () {
            alFabricTextColorListClick($(this));
        });

        // $("#pcTextOptionFont").on("change",function () {
        //     alFabricTextFont();
        // });

        $("#pcTextOptionFontList").on("click", ">div", function () {
            alFabricTextFontListClick($(this));
        });

        $("#pcTextOptionFontSizeList").on("click", ">div", function () {
            alFabricTextFontSizeListClick($(this));
        });

        $(".pcTemplateList").on("click", ".pcTemplateCreate", function () {
            pcTemplateChange(this);
        });

        $(".pcEditorLeftUploadArea,#photoStartUpload,.sh-tab-item-active .sh-twi-2-tab-item-media-box p").click(function () {
            $("#pcEditorLeftUploadAreaFile").get(0).click();
        });

        $("#pcEditorLeftUploadAreaFile").change(function (e) {
            pcFileAdd(e.target.files);
        });

        $(".pcEditorLeftImageList").on("click", ".pcEditorLeftImageDelete", function () {
            pcImageRemove(this);
        });

        $(".pcEditorLeftFuncsDeleteAll").click(function () {
            pcImageRemoveAll();
        });

        $("#pcEditorRightHeaderTemplate").click(function () {
            pcTemplateShow();
        });

        $(".pcTemplateClose").click(function () {
            pcTemplateHide();
        });

        $("#pcEditorRightHeaderEmpty").click(function () {
            pcFabricEmpty();
        });

        $("#pcEditorRightHeaderAutoFill").click(function () {
            pcFabricAutoFill(true);
        });

        $("#pcEditorRightHeaderBW").click(function () {
            pcFabricBW();
        });

        $("#pcEditorRightHeaderBackground").click(function () {
            $("#pcBackgroundInput").get(0).click();
        });

        $("#pcEditorRightHeaderBackgroundPattern").click(function () {
            $(".pcEditorRightHeaderPattern").css("display", "flex");
        });

        $(".pcEditorRightHeaderPatternList").on("click", ">img", function () {
            pcFabricBackgroundPattern($(this));
        })

        $("#pcBackgroundInput").on("input", function () {
            pcFabricBackgroundColor($(this).val());
        });

        $("#pcEditorRightHeaderAddText").click(function () {
            pcAddTextOpen();
        });
        $(".pcAddTextClose").click(function () {
            pcAddTextCloes();
        });
        $(".pcAddTextBtn").click(function () {
            pcAddTextOk();
        });

        function pcAddTextOk() {
            $(".pcAddText").css("display", "flex");
            if ($("#pcAddTextInput").val() !== "")
                pcFabricTextAdd($("#pcAddTextInput").val());
            pcAddTextCloes();
        }
        function pcAddTextCloes() {
            $(".pcAddText").hide();
        }

        function pcAddTextOpen() {
            $(".pcAddText").css("display", "flex");
            $("#pcAddTextInput").val("Sample Text");
            $("#pcAddTextInput").select();
        }

        $('html').keyup(function (e) {
            if (e.keyCode === 46 && e.target.tagName != "INPUT" && e.target.tagName != "TEXTAREA") {
                pcFabricImageRemove();
            }
            else if (e.keyCode === 83 && e.target.tagName != "INPUT" && e.target.tagName != "TEXTAREA") {
                var base64String = pc.fabric.mainCanvas.toDataURL({
                    format: 'jpeg',
                    multiplier: 0.5,
                    quality: 0.8
                });

                const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
                    const byteCharacters = atob(b64Data);
                    const byteArrays = [];

                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        const slice = byteCharacters.slice(offset, offset + sliceSize);

                        const byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);
                        byteArrays.push(byteArray);
                    }

                    const blob = new Blob(byteArrays, { type: contentType });
                    return blob;
                }

                const contentType = 'image/jpeg';
                const b64Data = base64String.substr(base64String.indexOf(',') + 1);

                const blob = b64toBlob(b64Data, contentType);
                const blobUrl = URL.createObjectURL(blob);

                var url = window.URL || window.webkitURL;
                link = url.createObjectURL(blob);
                var a = document.createElement("a");

                var fileName = pc.cur.template.thumbSrc;
                fileName = fileName.split("/");
                fileName = fileName[fileName.length - 1];

                a.setAttribute("download", fileName);
                a.setAttribute("href", link);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

            }
            else if (e.keyCode === 84 && e.target.tagName != "INPUT" && e.target.tagName != "TEXTAREA" && pc.cur.mode == "addTemplate") {
                pcProjectSaveTemplate();
            }
            pcOptSyns();
        });


        $("#pcEditorRightHeaderNew").click(function () {
            pcProjecNew();
        });

        //DropAble

        $('.pcEditorLeftUploadArea').droppable();

        $(".pcEditorRightEditAreaCon").droppable({
            // over: function (event, ui) {
            //     pcFabricOver(event, ui);
            // },
            // out: function (event, ui) {
            //     pcFabricOut(event, ui);
            // },
            // drop: function (event, ui) {
            //     pcFabricOut(event, ui);
            //     pcFabricDrop(event, ui);
            // }
        });

        $(".pcEditorLeftImageList").on("dragstart", function (e) {
            pc.cur.imageListDragStart = e.target;
        })

        $(".pcEditorLeftImageList").on("dragend", function (e) {
            pc.cur.imageListDragStart = false;
        })

        $(document).on("mousemove", function (event) {
            // pcFabricMouseMove(event);
        });

        $('.pcEditorLeftUploadArea').on('dragover', function (e) {
            e.preventDefault();
            e.stopPropagation();
            pcDropDragOver();
        });
        $('.pcEditorLeftUploadArea').on('dragenter', function (e) {
            e.preventDefault();
            e.stopPropagation();
        });
        $('.pcEditorLeftUploadArea').on('dragleave', function (e) {
            e.preventDefault();
            e.stopPropagation();
            pcDropDragLeave();
        });
        $('.pcEditorLeftUploadArea').on('drop', function (e) {
            if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.files.length) {
                e.preventDefault();
                e.stopPropagation();
                pcDropDragLeave();
                pcFileAdd(e.originalEvent.dataTransfer.files);
            }
        });
});